import { instance } from '@/services/avik-api-gateway'
import { AxiosResponse } from 'axios'
import { Permission } from '@/types/permission'

export function createPermission(
  body: Partial<Permission>
): Promise<AxiosResponse<Permission>> {
  return instance.post(`/iam/permission`, body)
}
